import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Paperclip, Trash2, Upload, Loader2 } from "lucide-react";

const kb = (n) => (n > 1048576 ? `${(n / 1048576).toFixed(1)} MB` : `${Math.max(1, Math.round(n / 1024))} KB`);

const FileRow = ({ f, reload }) => {
  const [usage, setUsage] = useState(f.usage || "");
  const saveUsage = async () => {
    if (usage === (f.usage || "")) return;
    try { await api.patch(`/email-agent/files/${f.id}`, { usage }); toast.success("Αποθηκεύτηκε"); }
    catch { toast.error("Σφάλμα"); }
  };
  const del = async () => {
    if (!window.confirm(`Διαγραφή «${f.filename}»;`)) return;
    await api.delete(`/email-agent/files/${f.id}`);
    reload();
  };
  return (
    <li className="flex flex-col sm:flex-row sm:items-center gap-2 py-2.5 border-b border-slate-100 last:border-0" data-testid={`email-agent-file-${f.id}`}>
      <div className="sm:w-60 min-w-0 flex items-center gap-2 text-sm text-slate-800">
        <Paperclip className="w-4 h-4 text-slate-400 shrink-0" />
        <span className="truncate" title={f.filename}>{f.filename}</span>
        <span className="text-[11px] text-slate-400 shrink-0">{kb(f.size)}</span>
      </div>
      <Input value={usage} onChange={(e) => setUsage(e.target.value)} onBlur={saveUsage} placeholder="Πότε να το επισυνάπτει;" className="flex-1 text-sm h-8" data-testid={`email-agent-file-usage-${f.id}`} />
      <Button variant="ghost" size="sm" onClick={del} data-testid={`email-agent-file-delete-${f.id}`}><Trash2 className="w-4 h-4 text-rose-600" /></Button>
    </li>
  );
};

export const AgentFiles = ({ files, reload }) => {
  const ref = useRef(null);
  const [usage, setUsage] = useState("");
  const [up, setUp] = useState(false);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 20 * 1024 * 1024) return toast.error("Έως 20MB");
    const fd = new FormData();
    fd.append("file", file);
    fd.append("usage", usage);
    setUp(true);
    try { await api.post("/email-agent/files", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Ανέβηκε"); setUsage(""); reload(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Σφάλμα"); }
    finally { setUp(false); if (ref.current) ref.current.value = ""; }
  };
  return (
    <section className="border border-slate-200 rounded-lg p-5 bg-white space-y-3" data-testid="email-agent-files">
      <p className="text-xs text-slate-600">Ο agent επισυνάπτει μόνος του ένα αρχείο στο πρόχειρο όταν ταιριάζει με την οδηγία «πότε».</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <Input value={usage} onChange={(e) => setUsage(e.target.value)} placeholder="π.χ. Όταν ζητούν τιμές ή δείγμα καταλόγου" className="flex-1 text-sm" data-testid="email-agent-upload-usage-input" />
        <input ref={ref} type="file" className="hidden" onChange={(e) => upload(e.target.files?.[0])} data-testid="email-agent-upload-input" />
        <Button onClick={() => ref.current?.click()} disabled={up} data-testid="email-agent-upload-btn">
          {up ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <Upload className="w-4 h-4 mr-1" />} Ανέβασμα αρχείου
        </Button>
      </div>
      <ul data-testid="email-agent-files-list">
        {files.map((f) => <FileRow key={f.id} f={f} reload={reload} />)}
        {!files.length && <li className="text-sm text-slate-500 py-3">Δεν υπάρχουν αρχεία ακόμη.</li>}
      </ul>
    </section>
  );
};
